import {
    FORM_EDITOR
} from "../../constants/action-types";
const initialState = {
    form_editor_saved: null,
    form_design_update: null,
    form_by_id: null,
    form_editor_update: [],
    webhook_data: null,
    form_fields: null,
    editor_configurations: null,
    embed_data: null
}

const FormEditor = (state = initialState, action) => {
    switch (action.type) {

        
        case FORM_EDITOR.SAVE: {
            return Object.assign({}, state, {
                form_editor_saved: action.payload
            });
        }
        case FORM_EDITOR.UPDATE_FORM_DESIGN: {
            return Object.assign({}, state, {
                form_design_update: action.payload
            });
        }
        case FORM_EDITOR.GET_BY_ID: {
            return Object.assign({}, state, {
                form_by_id: action.payload
            });
        }
        case FORM_EDITOR.UPDATE: {
            return Object.assign({}, state, {
                form_editor_update: action.payload
            });
        }
        case FORM_EDITOR.GET_WEBHOOK_BY_CLIENT: {
            return Object.assign({}, state, {
                webhook_data: action.payload
            });
        }
        case FORM_EDITOR.GET_FORM_FIELDS: {
            return Object.assign({}, state, {
                form_fields: action.payload
            });
        } 
        case FORM_EDITOR.GET_CONFIGURATIONS: {
            return Object.assign({}, state, {
                editor_configurations: action.payload
            });
        } 
        case FORM_EDITOR.GET_EMBED_PAGE_DATA: {
            return Object.assign({}, state, {
                embed_data: action.payload
            });
        } 
        default:
            return state
    }

}

export default FormEditor